module.exports = __webpack_public_path__ + "img/digital_yunwei.872c0ce3.png";